import { http } from '../../../../api/http';
import type { KardexResponse, KardexGeneralItem } from '../types/kardex.types';

export const kardexService = {
  async getKardex(idArticulo: number, idDeposito?: number, fechaDesde?: string, fechaHasta?: string): Promise<KardexResponse> {
    const params = new URLSearchParams();
    params.append('idArticulo', idArticulo.toString());
    if (idDeposito) params.append('idDeposito', idDeposito.toString());
    if (fechaDesde) params.append('fechaDesde', fechaDesde);
    if (fechaHasta) params.append('fechaHasta', fechaHasta);
    const response = await http.get(`/inventario/kardex?${params.toString()}`);
    return response.data;
  },

  async getKardexGeneral(): Promise<KardexGeneralItem[]> {
    const response = await http.get('/inventario/kardex/general');
    return response.data;
  },
};
